<!--
//================================================================================
// ID:BC010
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC010
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/25 | 富士通株式会社         | 新規作成
//================================================================================
-->
<template>
	<div class="contents__main">
		<div class="ichiran__main">
			<pagination
				:name="'ページヘッダー'"
				:headerTitle="'申込み履歴一覧'"
				:class="'margin__bottom-3'"
				:listCount="form.listCount"
				:displaySortFlg="false"
				:tabindex="1"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageHeader" />
			<div align="center">
				<div class="contents__div--PC">
					<table border="1" class="contents__table--itiran back__color" id="list">
						<thead>
							<tr id="listheader">
								<th id="listtitle01">申込日</th>
								<th id="listtitle02">受付<br />番号</th>
								<th id="listtitle03">公募年月<br/>募集の種類<br/>住宅の種別</th>
								<th id="listtitle04">申込<br />地区番号</th>
								<th id="listtitle05">申込区分</th>
								<th id="listtitle06">住宅名<br/>代表的な所在地</th>
								<th id="listtitle07">状況</th>
								<th id="listtitle08">申込内容<br />参照・変更</th>
							</tr>
						</thead>
						<tbody>
							<tr id="listcountents" v-for="row in disp.meisaiList" :key="row.noRenzoku">
								<td id="listtd">{{ row.dtMosikomiHyoji }}</td>
								<td id="listtd">{{ row.noUketuke }}</td>
								<td id="listtd2">{{ row.ymBosyu }}<br />{{ row.nmBosyu }}<br />{{ row.nmZyutaku }}</td>
								<td id="listtd">{{ row.noMouchiku }}</td>
								<td id="listtd2">{{ row.nmMosikomi }}</td>
								<td id="listtd2">{{ row.jyutakuName }}<br />{{ row.kusicyo }}</td>
								<td id="listtd">{{ row.nmCd }}</td>
								<td v-if="row.refChangebtn == '変更'" id="listtd">
									<input type="button" :value="row.refChangebtn" v-on:click="clickSelectDetailBtn(row)" class="contents__btn--confirm detail_btn" tabindex="11"/>
								</td>
								<td v-else id="listtd">
									<input type="button" :value="row.refChangebtn" v-on:click="clickSelectDetailBtn(row)" class="contents__btn--normal detail_btn" tabindex="11"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="contents__div--MOBILE">
					<table class="contents__table--stripe contents__even">
						<tbody>
							<tr class="contents__input--tr" v-for="row in disp.meisaiList" :key="row.noRenzoku">
								<td class="line__height">
									<label>申込日</label><label id="font__weight">：{{ row.dtMosikomiHyoji }}</label><br/>
									<label>受付番号</label><label id="font__weight">：{{ row.noUketuke }}</label><br/>
									<label>公募年月</label><label id="font__weight">：{{ row.ymBosyu }}</label><br/>
									<label>募集の種類</label><label id="font__weight">：{{ row.nmBosyu }}</label><br/>
									<label>住宅の種別</label><label id="font__weight">：{{ row.nmZyutaku }}</label><br/>
									<label>申込地区番号</label><label id="font__weight">：{{ row.noMouchiku }}</label><br/>
									<label>申込区分</label><label id="font__weight">：{{ row.nmMosikomi }}</label><br/>
									<label>住宅名</label><label id="font__weight">：{{ row.jyutakuName }}</label><br/>
									<label>代表的な所在地</label><label id="font__weight">：{{ row.kusicyo }}</label><br/>
									<label>状況</label><label id="font__weight">：{{ row.nmCd }}</label>
									<span v-if="row.refChangebtn == '変更'" class="btn_detail">
										<input type="button" :value="row.refChangebtn" v-on:click="clickSelectDetailBtn(row)" class="contents__btn--confirm" id="btn_detail--all" tabindex="11"/>
									</span>
									<span v-else class="btn_detail">
										<input type="button" :value="row.refChangebtn" v-on:click="clickSelectDetailBtn(row)" class="contents__btn--normal" id="btn_detail--all" tabindex="11"/>
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination
				:name="'ページフッター'"
				:class="'margin__top-10 margin-bottom-foot'"
				:listCount="form.listCount"
				:displaySortFlg="false"
				:displayFotterFlg="true"
				:tabindex="120"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageFotter" />
			</div>
		</div>
	</div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_toTop, co_toTrans } from '@/common/screenUtility.js';

import { HTTP_STATUS } from '@/const/const.js';
import { STORE_VIEW_PROGRESS, STORE_VIEW_CLEAR_PAGE } from '@/const/store.js';
import { PATH_BC010 } from '@/const/route.js';

export default {
	name: "BC010",
	components: {
		'pagination': Pagination,
	},
	data: function () {
		return {
			form: {
				meisaiList: [],			// 募集住宅一覧リスト
				listCount: 0, 			// 申込み履歴一覧件数
			},
			disp: {
				meisaiList: [],			// 募集住宅一覧リスト(表示用)
			}
		}
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.pageHeader.focus();
	},
	created: async function() {

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// ページ情報クリア
		this.$store.commit(STORE_VIEW_CLEAR_PAGE);

		// 申込み履歴一覧情報を取得
		let self = this;
		let listData = await co_post(PATH_BC010, null, function (res, handle) {

			if (res.status == HTTP_STATUS.OK) {
				return handle(res);
			} else {
				// ローディング表示終了
				self.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		});

		// 申込み履歴一覧を一覧に設定
		this.form.meisaiList = listData.mosikomiIchiranList;
		this.disp.meisaiList = this.form.meisaiList;
		this.form.listCount = this.form.meisaiList.length;

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {
		// ページ切替ボタン押下処理
		clickPageSwitchBtn: function (startIndex, endIndex) {

			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.form.meisaiList[i]);
			}
			this.disp.meisaiList = eitMeisaiList;

			// ページトップへ遷移
			co_toTop();
		},
		// 参照変更ボタン押下処理
		clickSelectDetailBtn: function (row){
			// 申込み内容確認画面に遷移
			let params = {
							dtMosikomi: row.dtMosikomi,
							noRenzoku: row.noRenzoku,
							refChangebtn: row.refChangebtn,
							dtSyokaiMosikomi: row.dtSyokaiMosikomi
						};
			co_toTrans('BC011', params);
		}
	}
}
</script>
<style scoped>


/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.contents__main{
		margin-left: 0% !important;
		margin-right: 0% !important;
	}
	.contents__h2 {
		margin: 0 0 0px 3px !important;
		padding: 0 0 0px 8px !important;
	}
	.ichiran__main {
		margin: 8px;
	}
	#listtd2 {
		text-align: left;
		font-size: 16px;
		padding-left: 1%;
		padding-top: 1%;
		padding-bottom: 1%;
		line-height: 21px;
	}
	/* 申込日(ヘッダ) */
	#listtitle01 {
		width: 13%;
		font-size: 16px;
	}
	/* 受付番号(ヘッダ) */
	#listtitle02 {
		width: 6%;
		font-size: 16px;
		line-height: 22px;
	}
	/* 公募年月・募集の種類・住宅の種別(ヘッダ) */
	#listtitle03 {
		width: 24%;
		font-size: 16px;
		line-height: 22px;
		padding-top: 1%;
		padding-bottom: 1%;
	}
	/* 申込地区番号(ヘッダ) */
	#listtitle04 {
		width: 7%;
		font-size: 16px;
		line-height: 22px;
	}
	/* 申込区分(ヘッダ) */
	#listtitle05 {
		width: 14%;
		font-size: 16px;
	}
	/* 住宅名・代表的な所在地(ヘッダ) */
	#listtitle06 {
		width: 20%;
		font-size: 16px;
		line-height: 22px;
	}
	/* 状況(ヘッダ) */
	#listtitle07 {
		width: 6%;
		font-size: 16px;
	}
	/* 申込内容参照・変更(ヘッダ) */
	#listtitle08 {
		width: 10%;
		font-size: 16px;
		line-height: 22px;
	}

	.back__color {
		table-layout: fixed;
	}

	.back__color tr:nth-child(even) {
		background-color: #f1f2f5;
	}

}
/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	.ichiran__main {
		position: relative;
		align-items: center;
		margin-left: auto;
		margin-right: auto;
		margin-top: 10px;
	}
	#font__weight {
		font-weight: normal;
	}
	.line__height {
		line-height: 27px !important;
		padding-bottom: 20px;
	}
	#btn_detail--all {
		padding: 0.2em 1.6em !important;
		margin: 0px;
		bottom: 1px;
	}	
}
</style>
